import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ViewConfigurationService } from './view-configuration.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [ViewConfigurationService]
})
export class ViewConfigurationModule { }
